import { urlParams } from "../get-url-params";
import { acceptedLang } from "./accepted-langs";
import storage from "../storage/storage";

function randomIntFromTo(min, max) {return Math.floor(Math.random() * (max - min + 1) + min)}

// Parse ballsInSec URL param (int 1–10), default 5
const rawBallsInSec = parseInt(urlParams.get("ballsInSec"), 10);
export const ballsInSecParam =
  Number.isFinite(rawBallsInSec) && rawBallsInSec >= 1 && rawBallsInSec <= 10
    ? rawBallsInSec
    : 5;

export const loginParams = {
  "companyId": urlParams.get('companyId') || "1",
  "uid": urlParams.get('uid') || "rnd" + randomIntFromTo(1, 10000) + "x" + randomIntFromTo(1, 10000) + "",
  "currency": urlParams.get('currency') || 'EUR',
  "token": urlParams.get('token') || null,
  "language": acceptedLang(urlParams.get('language') || urlParams.get('lang')) ? urlParams.get('language') || urlParams.get('lang') : "en",
  "countryCode": urlParams.get('countryCode'),
  "avatar_id": 0,
  "version": urlParams.get('version') || null,
  "autoBet": urlParams.get('autobet') || false,
  "hideHeader": urlParams.get('hideHeader') || false,
  "show_help": urlParams.get('showHelp') || false,
  "fullscreen": urlParams.get('fullscreen') || false,
  "crypto": urlParams.get('crypto') || false,
  "region": urlParams.get('region') || "default",
  "backUrl": urlParams.get('backUrl') || "",
  "launchId": urlParams.get('launchId') || null,
  "userDefinedUsername": storage.get('userDefinedUsername') || '',
  // expose for convenience if needed elsewhere
  "ballsInSec": ballsInSecParam,
}
